/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstylegrafikhint4Inputs */

const en_aiflowstylegrafikhint4 = /** @type {(inputs: Aiflowstylegrafikhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shapes and a motif`)
};

const de_aiflowstylegrafikhint4 = /** @type {(inputs: Aiflowstylegrafikhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formen und Motiv`)
};

/**
* | output |
* | --- |
* | "Shapes and a motif" |
*
* @param {Aiflowstylegrafikhint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstylegrafikhint4 = /** @type {((inputs?: Aiflowstylegrafikhint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstylegrafikhint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstylegrafikhint4(inputs)
	return de_aiflowstylegrafikhint4(inputs)
});
export { aiflowstylegrafikhint4 as "aiFlowStyleGrafikHint" }